import React from 'react';
import { FormattedMessage } from 'react-intl';
import { createColumnDefinitionBuilder } from 'ui-components/components/react-table-wrapper/create-column-definition-builder';
import { CellPropTypes } from '../../../../../../prop-types/react-table';
import { useImportContext } from '../../import-context';
import { SelectCsvColumn } from '../../select-csv-column/select-csv-column';
import { messages } from './messages';
import styles from './styles.module.css';

const CsvHeaderCell = ({ row }) => {
  const templateAttribute = row.original;
  const { getMappedCsvColumn } = useImportContext();

  const csvColumn = getMappedCsvColumn(templateAttribute) || {};

  return (
    <div className={styles['csv-header-cell']}>
      <SelectCsvColumn csvColumn={csvColumn} templateAttribute={templateAttribute} />
    </div>
  );
};

CsvHeaderCell.propTypes = CellPropTypes;

export const createCsvHeaderColumnDefinition = createColumnDefinitionBuilder({
  accessor: 'yourColumnHeader',
  Header: <FormattedMessage {...messages.yourColumnHeader} />,
  Cell: CsvHeaderCell,
  width: 2,
});
